import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../utils/axios';
import { SUBSCRIBE_PACKAGE_POSITION_LIST } from 'src/constants/queryKeys';

export const networkGetSubscribePackagePositionInfo = async (planetId) => {
  const res = await axiosInstance.post(`SubscribePackagePosition/Info/${planetId}`);
  return res;
};

export const networkGetSubscribePackagePositionList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`SubscribePackagePosition/List/${pageIndex}/${pageSize}/`, payload);
  return res;
};

export function useFetchSubscribePackagePositionList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [SUBSCRIBE_PACKAGE_POSITION_LIST, payload, pageIndex],
    queryFn: () => networkGetSubscribePackagePositionList(payload, pageIndex, pageSize),
  });
}

export const networkUpdateSubscribePackagePosition = async (planetId, payload) => {
  const res = await axiosInstance.post(`SubscribePackagePosition/Update/${planetId}`, payload);
  return res;
};

export const networkRemoveSubscribePackagePosition = async (planetId) => {
  const res = await axiosInstance.post(`SubscribePackagePosition/Remove/${planetId}`);
  return res;
};

export const networkCreateSubscribePackagePosition = async (payload) => {
  const res = await axiosInstance.post('SubscribePackagePosition/Insert', payload);
  return res;
};
